<script setup>
import { useRouter } from 'vue-router';
import { computed, ref, onMounted, onBeforeUnmount, watch } from 'vue';
// import axios from 'axios';
import { useTriviaStore } from '@/stores/trivia'
import segmentEditor from '@/components/SegmentEditor.vue'
import {v4 as uuid} from 'uuid';
import { JaTableDelete, CgAddR } from "@kalimahapps/vue-icons"; 

const router = useRouter();

function keyHandler(ev) {
  if(['ArrowUp','ArrowDown',].indexOf(ev.code) > -1) {
        ev.preventDefault();
  }
  // const preventKey = (tools.value.scores || tools.value.questions); // Ignore keypresses if question editor or scoreboard is open
  switch(ev.key) {
    default: break;
    case('Escape'): {
      activeItemKey.value = null;
    }
    case('ArrowUp'): {
      changeRecord();
      break;
    }
    case('ArrowDown'): {
      changeRecord(true);
      break;
    }
  }
}

onMounted(() => {
  window.addEventListener('keydown', keyHandler);
});
onBeforeUnmount(() => {
  window.removeEventListener('keydown', keyHandler);
});


const useStore = useTriviaStore();
const store = computed(() => useStore.all);
const CurrentGame = computed(() => store.CurrentGame);

watch(CurrentGame, (newVal) => {
  console.log('current game changed', newVal);
})





let activeType = ref(null);
const typeData = computed(() => {
  if (activeType.value) {
    return store.value[activeType.value];
  }
  return [];
})

const activeItemKey = ref(null);
const activeItem = computed(() => {
  if (activeItemKey.value) {
    return typeData.value.filter(f => f._id === activeItemKey.value)[0]
  }
  return null;
});

const selectedItems = ref([]);
const mouseoverMode = ref(false);
// const mouseoverAdd = ref(null);

function enterMouseover(id, add) {
  mouseoverMode.value = true;
  // mouseoverAdd.value = add;
  mouseoverItem(id);
  registerClick(id);
}

function endMouseover(id) {
  mouseoverMode.value = false;
}

function mouseoverItem(id) {
  if (mouseoverMode.value) {
    const x = selectedItems.value.indexOf(id);
    if (x === -1) {
      if (!event.shiftKey) {
        selectedItems.value.push(id);
      } else {
        const lastSelected = selectedItems.value[selectedItems.value.length - 1];
        const lastSelectedIndex = typeData.value.findIndex((x) => x._id === lastSelected);
        const currentIndex = typeData.value.findIndex((x) => x._id === id);
        const start = Math.min(lastSelectedIndex, currentIndex);
        const end = Math.max(lastSelectedIndex, currentIndex);
        for (let a = start; a <= end; a += 1) {
          if (typeData.value[a] && typeData.value[a]._id) selectedItems.value.push(typeData.value[a]._id);
        }
      }
    } else {
      selectedItems.value.splice(x, 1);
    }
    // if (x === -1 && mouseoverAdd.value) {
      // selectedItems.value.push(id);
    // if (x > -1 && !mouseoverAdd.value) selectedItems.value.splice(x, 1);
  }
}

function setActiveItem(id) {
  activeItemKey.value === id ? activeItemKey.value = null : activeItemKey.value = id;
}

const mouseClicks = ref([]);

function registerClick(id) {
  if (mouseClicks.value.length > 1 && mouseClicks.value.indexOf(id) > -1) {
    setActiveItem(id);
    mouseClicks.value = [];
  } else {
    mouseClicks.value.push(id);
    setTimeout(() => {
      const x = mouseClicks.value.indexOf(id);
      mouseClicks.value.splice(x, 1);
    }, 1000);
  }
}

const newModel = computed(() => {
  const modelData = {};
  const type = activeType.value;
  if (type) {
    const fields = Object.entries(store.value.schema[type]).filter(n => n[0] !== '_id');
    // const dateCreated = fields.filter(n => n[1].label === 'Date Created')[0][0];
    for (let a = 0; a < fields.length; a += 1) {
      if (Array.isArray(fields[a][1].type)) {
        modelData[fields[a][0]] = [];
      } else if (fields[a][1].metaType === 'TriviaAnswers') {
        modelData[fields[a][0]] = {
          text: '',
          highlight: [],
          reorder: [],
          hint: { show: false, amount: null, delay: false }
        }
      } else if(fields[a][1].type === 'Object') {
        modelData[fields[a][0]] = {};
      } else {
        modelData[fields[a][0]] = null;
      }
    }
    modelData.dateCreated = new Date();
    modelData.dateUpdated = new Date();
  }
  return modelData;
});

function addNew(modelData) {
  if (activeType.value) {
    if (!modelData) {
      const model = JSON.parse(JSON.stringify(newModel.value));
      useStore.saveData({collection: activeType.value, records: [model]});
    } else {
      // module for importing previously-written questions
      // const models = [];
      // const fields = Object.entries(store.value.Schema[activeType.value]);
      // useStore.activeGame.rounds.forEach((round) => {
      //   Object.entries(round).forEach((q) => {
      //     let model = JSON.parse(JSON.stringify(newModel.value));
      //     const answer = fields.filter(n => n[1].label === 'Answer Data')[0][0]
      //     const question = fields.filter(n => n[1].label === 'Question Data')[0][0]
      //     const time = fields.filter(n => (n[1].label === 'Time Allotted'))[0][0]
      //     const cat = fields.filter(n => (n[1].label === 'Category'))[0][0]
      //     model[answer] = q[1].a ? JSON.parse(JSON.stringify(q[1].a)) : {};
      //     model[question] = q[1].q ? JSON.parse(JSON.stringify(q[1].q)) : {};
      //     model[cat] = q[1].cat || null;
      //     // Alotted typo in older questions. Condition can be removed once all questions are imported
      //     model[time] = q[1].timeAlotted || q[1].timeAllotted;
      //     models.push(model);
      //     // store.value[activeType.value].push(model)
      //   });
      // })
      // console.log('using', models);
      // useStore.saveData({ collection: activeType.value, records: models });
    }
  }
}

// function saveData(toSave) {
//   // TODO add loading indicator
//   axios.post(`${secrets.restApi}/questions`, { collection: activeType.value, records: toSave }, auth(user.value))
//   .then(function (response) {
//     response.data.newData.forEach(i => store.value[activeType.value].push(i));
//     console.log('saved');
//   //   for (let a = 0; a < Object.keys(response.data).length; a += 1) {
//   //     const keys = Object.keys(response.data);
//   //     const key = keys[a];
//   //     store[key] = response.data[key];
//   //   }
//   //   console.log(response.data);
//   });
// }

function deleteSelected() {
  if (selectedItems.value.length > 1) {
    useStore.deleteBulkData({ records: selectedItems.value, collection: activeType.value })
  } else {
    useStore.deleteData({ record: selectedItems.value[0], collection: activeType.value })
  }
}

function clearSelected() {
  selectedItems.value = [];
}

function changeRecord(down) {
  if (activeType.value && activeItemKey.value) {
    const currentItem = typeData.value.findIndex((x) => x._id === activeItemKey.value);
    const nextItem = down ? typeData.value[currentItem + 1] : typeData.value[currentItem - 1];
    if (nextItem && nextItem._id) {
      activeItemKey.value = nextItem._id;
    }
  }
};

function fieldData(item, key) {
  const field = store.value.schema[activeType.value][key].field;
  let data = item[key];
  switch (key) {
    default: break;
    case('dateUpdated'):
    case('dateCreated'): {
      data = new Date(item[key]).toString().substr(0, 15);
      break;
    }
    case('playHistory'): {
      if (activeType.value === 'games') {
        data = item[key].length ? `Played ${item[key].length} time${item[key].length > 1 ? 's' : ''}` : 'Never Played';
      }
      if (activeType.value === 'venues') {
        // TODO add venue play history
        data = '';
      }
      break;
    }
  }
  return data;
}

const displayFields = computed(() => {
  if (activeType.value && store.value.schema[activeType.value]) {
  const displayFields = Object.entries(store.value.schema[activeType.value]).reduce((acc, [key, value]) => {
    if (value.display) {
      acc[key] = value;
    }
    return acc;
  }, {});
    return displayFields;
  }
  return [];
})

function changeActiveType(type) {
  activeType.value = type;
  activeItemKey.value = null;
  selectedItems.value = [];
}

const showLoadOptions = ref(false);


async function loadGame(id, existing) {
  if (existing) {
    await useStore.loadGame(id).then(() => {
      console.log('game loaded', store.value.CurrentGame);
      showLoadOptions.value = false;
      router.push('/present');
    });
  } else {
    await useStore.copyGame(id).then(() => {
      console.log('game loaded', store.value.CurrentGame);
      showLoadOptions.value = false;
      router.push('/present');
    });
  }
}

async function previewGame(id) {
  activeType.value = 'games';
  activeItemKey.value = id;
  selectedItems.value = [id];
}

function showAddItemButton(type) {
  switch (type) {
    default: return false;
    case('comments'):
    case('playHistory'): {
      return true;
    }
  }
}

function addItem(type) {
  switch (type) {
    default: break;
    case('comments'): {
      addComment();
      break;
    }
    case('playHistory'): {
      addPlayHistory();
      break;
    }
  }
}

const editComment = ref(null);

function addComment() {
  const id = uuid();
  activeItem.value.comments.splice(0, 0, { _id: id, date: new Date().toISOString().slice(0,10), comment: null });
  editComment.value = id;
}
function addPlayHistory() {
  activeItem.value.playHistory.splice(0, 0, { _id: uuid(), datePlayed: new Date().toISOString().slice(0,10), venue: null, });
}

function removeItem(type, index) {
  activeItem.value[type].splice(index, 1);
}

function updateData() {
  // Gets called when a single record is updated
  useStore.updateData({ collection: activeType.value, record: activeItem.value });
}

function updateGame() {
  // Gets called when CurrentGame game is updated
  useStore.updateData({record: store.value.CurrentGame, collection: 'games'});
}

function removeGame(index) {
  // Remove game from play history
  activeItem.value.playHistory.splice(index, 1);
}

const selectedRound = ref(null);
// const selectedQuestion = ref(null);

const selectQuestion = (id) => {
  // selectedQuestion.value = index;
  activeType.value = 'questions';
  activeItemKey.value = id;
}

const closeSelection = () => {
  activeItemKey.value = null;
  selectedRound.value = null;
  // selectedQuestion.value = null;
}

function addToCurrentGame(multiAdd) {
  if (!multiAdd) {
    // Add question to current game
    useStore.addQuestionToGame(activeItemKey.value);
  } else {
    // Add multiple questions to current game
    useStore.addMultipleQuestionsToGame(selectedItems.value);
  }
}

function duplicateGame() {
  useStore.duplicateGame(activeItemKey.value);
}

function gameHasChanges() {
  if (activeType.value === 'games'
  && activeItemKey.value
  && store.value.CurrentGame
  && store.value.CurrentGame._id === activeItemKey.value) {
    const currentGame = store.value.CurrentGame;
    const activeGame = activeItem.value;
    if (currentGame && activeGame) {
      return JSON.stringify(currentGame) !== JSON.stringify(activeGame);
    }
  }
  return false;
}

</script>

<template>
  <!-- Access the state directly from the store -->
  <div
      class="data__manager">
    <h2>Question Manager</h2>
    <div
        v-for="dataType in ['questions', 'games', 'hosts', 'venues']"
        :key="dataType"
        style="display: inline-block">
      <div
          v-text="dataType.toUpperCase()"
          @click="changeActiveType(dataType)"
          :class="activeType === dataType ? 'data-type__active' : 'data-type'"
      />
    </div>
    <button
        @click="router.push('/present')">
      Active Game
    </button>
    <button
        @click="addNew()">
      Add New
    </button>
    <button
        v-if="activeType === 'games' && selectedItems.length"
        @click="showLoadOptions = !showLoadOptions"
        :disabled="selectedItems.length !== 1">
      Load Game
    </button>
    <div
        v-if="showLoadOptions">
      <button
          @click="loadGame(selectedItems[0], true)">
        Load Existing Game
      </button>
      <button
          @click="loadGame(selectedItems[0], false)">
        Create Copies of Game & Questions
      </button>
      <button
          @click="showLoadOptions = false">
        Cancel
      </button>
    </div>
    <button
        v-if="gameHasChanges()"
        @click="updateGame()">
      Save Changes To Game
    </button>
    <!-- Main Menu -->
    <button
        @click="addToCurrentGame(selectedItems.length > 1)"
        v-if="selectedItems.length && activeType === 'questions'">
      Add {{selectedItems.length > 1 ? 'Questions' : 'Question' }} to Game
    </button>
    <button
        :disabled="!selectedItems.length && !activeItemKey"
        @click="deleteSelected()">
      Delete Selected
    </button>
    <button
        :disabled="!selectedItems.length"
        @click="clearSelected()">
      Clear Selected
    </button>
    <!-- End Menu -->
    <!-- Type Table -->
    <Transition
        name="fade"
        mode="out-in">
      <div>
        <table
            class="table">
          <thead>
            <tr>
              <th
                  v-for="(field, index) in displayFields"
                  :key="index">
                {{field.label}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
                v-for="(item, indexPos) in store[activeType]"
                :key="item._id"
                class="table__item"
                :class="((store && store.CurrentGame && store.CurrentGame._id === item._id) || activeItemKey === item._id) ? 'table__item__active' : selectedItems.indexOf(item._id) > -1 ? 'table__item__selected' : ''"
                @click="registerClick(item._id)"
                @mouseover="mouseoverItem(item._id)"
                @mousedown.left="enterMouseover(item._id, selectedItems.indexOf(item._id) === -1)"
                @mouseup.left="endMouseover(item._id)">
                <td
                v-for="(field, index) in displayFields"
                :key="index">
                {{fieldData(item, index)}}
              </td>
              <td
                  id="idDisplay"
                  v-text="item._id ? item._id.slice(item._id.length - 7, item._id.length) : 'unsaved'"
              />
            </tr>
          </tbody>
        </table>
      </div>
    </Transition>
      <!-- </div>
                <td
                  v-for="field in Object.entries(store.Schema[activeType])"
                  :key="field[0]">
                <div
                    v-if="item[field[0]]">
                  <div
                      v-if="field[0] === '_id'">
                    {{indexPos + 1}}
                  </div>
                  <div
                      v-else-if="item[field[0]].linksChosen">
                    {{item[field[0]].linksChosen.length}}
                  </div>
                  <div
                      v-else-if="field[1].type === 'Date'">
                    {{new Date(item[field[0]]).toString().substr(0,15) || field[1].type}}
                  </div>
                  <div
                      v-else-if="field[1].metaType === 'TriviaQuestions'">
                    {{ item[field[0]].length }} Segments
                  </div>
                  <div
                      v-else-if="field[1].metaType === 'TriviaAnswers'">
                  </div>
                  <div
                      v-else>
                    {{item[field[0]]}}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Transition> -->
    <Transition
        name="fade"
        mode="out-in">
      <!-- Edit Table Item -->
      <div
          v-if="activeItemKey"
          class="edit__container">
        <button
            @click="closeSelection()">
          Close
        </button>
        <button
            :disabled="store.loading"
            @click="updateData()">
          <span
              v-if="!store.loading">
            Update Record
          </span>
          <span
              v-else>
            Updating...
          </span>
        </button>
        <button
            @click="duplicateGame()">
          Duplicate Game
        </button>
        <button
            @click="showLoadOptions = !showLoadOptions">
          Load Game
        </button>
        <div
            v-if="showLoadOptions">
          <button
              @click="loadGame(activeItemKey, true)">
            Load Existing Game
          </button>
          <button
              @click="loadGame(activeItemKey, false)">
            Create Copies of Game & Questions
          </button>
          <button
              @click="showLoadOptions = false">
            Cancel
          </button>
        </div>
        <span
            v-if="store.status"
            v-text="store.status"
        />
        <!-- Games Table Editor -->
        <div
            v-if="activeType === 'games'">
          <div
              v-for="field in Object.entries(store.schema[activeType])"
              :key="field[0]"
              class="fields">
            <div
                class="fields__header">
              <span
                  v-text="field[1].label"
              />
              <button
                  id="addItem"
                  v-if="showAddItemButton(field[0])"
                  class="ml-3 fields__button"
                  @click="addItem(field[0])">
                <CgAddR />
              </button>
            </div>
            <!-- Play History Editor -->
            <div
                v-if="field[0] === 'playHistory'">
              <ul>
                <li
                    v-for="(game, index) in activeItem[field[0]]"
                    :key="index"
                    class="fields__list">
                  <button
                      @click="removeItem('playHistory', index)"
                      class="fields__button__delete">
                    <JaTableDelete />
                  </button>
                  <span
                      @click="game.datePlayed = null"
                      v-if="game.datePlayed"
                      v-text="game.datePlayed"
                      class="mx-3"
                  />
                  <input
                      v-else
                      type="date"
                      v-model="game.datePlayed"
                  />
                  <span
                      v-if="game.venue"
                      v-text="store.venues.filter(v => v._id === game.venue)[0].name"
                      @click="game.venue = null"
                  />
                  <select
                      v-else
                      v-model="game.venue">
                    <option
                        v-for="venue in store.venues"
                        :key="venue._id"
                        :value="venue._id">
                      {{venue.name}}
                    </option>
                  </select>
                </li>
              </ul>
            </div>
            <!-- End Play History Editor -->
            <!-- Comments -->
            <div
                v-if="field[0] === 'comments'">
              <ul>
                <li
                    v-for="(comment, index) in activeItem[field[0]]"
                    :key="index"
                    class="fields__list">
                  <button
                      @click="removeItem('comments', index)"
                      class="fields__button__delete">
                    <JaTableDelete />
                  </button>
                  <span
                      v-text="new Date(comment.date).toLocaleDateString()"
                      class="mx-3"
                  />
                  <span
                      @click="editComment = comment._id"
                      v-if="editComment !== comment._id"
                      v-text="comment.comment"
                      class="mx-3"
                  />
                  <input
                      v-else
                      v-model="comment.comment"
                  />
                </li>
              </ul>
            </div>
            <!-- End Comments -->
            <!-- List of questions in game -->
            <div
                v-else-if="field[0] === 'rounds'">
              <div
                  v-for="(round, index) in activeItem[field[0]]"
                  :key="index">
                <h3
                    @click="selectedRound = index"
                    class="hover-gold"
                    v-text="`Round ${Number(index) + 1}`"
                />
                <div
                    v-if="selectedRound === index"
                    v-for="(question, qIndex) in round"
                    :key="qIndex">
                  <div
                      @click="selectQuestion(question._id)"
                      class="hover-gold">
                    <span
                      v-text="`${Number(qIndex) + 1}) `"
                    />
                    <span
                        v-text="store.questions.filter(q => q._id === question._id)[0].category"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Venues Table Editor -->
        <div
            v-if="activeType === 'venues'">
          <div
              v-for="field in Object.entries(store.schema[activeType])"
              :key="field[0]">
            {{field[1].label}}
            <div
                v-if="field[0] === 'name'">
              <input
                  v-model="activeItem[field[0]]"
                  placeholder="Venue Name"
              />
            </div>
          </div>
        </div>
        <!-- Questions Table Editor -->
        <div
            v-if="activeType === 'questions'">
          <button
              @click="addToCurrentGame()">
            Add to Current Game
          </button>
          <button
              v-for="(round, index) in CurrentGame"
              :key="index">
            {{index + 1}}
          </button>
          <!-- <div
              v-for="field in Object.entries(store.Schema[activeType])"
              :key="field[0]">
            {{field[1].label}}
            <input
                v-if="field[1].type === 'String' || field[1].type === 'Number'"
                v-model="activeItem[field[0]]"
            />
          </div> -->
          Used in {{activeItem.usedIn.length}} games
          <div
              v-for="game in activeItem.usedIn"
              :key="game._id">
            <span
                @click="previewGame(game._id)"
                style="cursor: pointer"
                v-text="game._id.slice(game._id.length - 4, game._id.length)"
            />
          </div>
          <segment-editor
              :workingQuestion="activeItem"
              :collection="activeType"
              :manager="true"
              :hideAnswers="false"
          />
        </div>
      </div>
    </Transition>
  </div>
</template>
<style lang="scss" scoped>
  .data {
    &__manager {
      background: black;
      color: white;
      cursor: default;
    }
  }
  h2 {
    text-align: center;
  }
  // div {
  //   color: white;
  // }
  .data-type {
    padding: 15px 15px;
    font-size: 2em;
    &__active {
      @extend .data-type;
      background-color: lighten(gold, 15%);
      color: darkslategrey;
    }
  }
  .table {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    &__item {
      background-color: lighten(darkslategrey, 15%);
      &__active {
        background-color: gold;
      }
      &__selected {
        background-color: lighten(darkslategrey, 25%);
      }
    }
  }
  .edit {
    &__container {
      background: lighten(cornflowerblue, 5%);
      border-radius: 15px;
      padding: 2vh 3vw;
      position: absolute;
      top: 20vh;
      left: 30vw;
    }
  }
  .hover-gold {
    &:hover {
      cursor: pointer;
      color: gold;
    }
  }
  .fields {
    background:darkslategrey;
    color: white;
    margin: 1vh 0;
    padding: 1vh 2vw;
    border-radius: 15px;
    font-size: 1.3em;
    &__list {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1vh 0;
      padding: 1vh 2vw;
      border-radius: 15px;
      background: rgb(70, 117, 117);
      color: white;
      &__button {
        background: transparent;
        border: none;
        color: white;
        font-size: 1.3em;
        &:hover {
          cursor: pointer;
          color: red;
        }
      }
    }
    &__header {
      font-weight: bold;
      padding: 5px 10px;
      border-radius: 10px;
    }
    &__button {
      background: transparent;
      border: none;
      color: white;
      font-size: 1.3em;
      &:hover {
        color: gold;
        cursor: pointer;
      }
      &__delete {
        @extend .fields__button;
        color: darkred;
        &:hover {
          color: red;
        }
      }
    }
  }
</style>